<div class="tts-container" *ngIf="courseSelected$ | async">
  <!-- Initial button -->
  <button mat-raised-button
          color="primary"
          (click)="ttsInitialize()" 
          class="tts-button"
          *ngIf="(isTtsNotInitialized$ | async)">
    <mat-icon class="tts-icon" title="Text to Speech" aria-label="Text to Speech">record_voice_over</mat-icon>
    <span class="tts-text">Text to Speech</span>
  </button>

  <!-- Controls when active -->
  <div class="tts-controls" *ngIf="!(isTtsNotInitialized$ | async)">
    <select [(ngModel)]="rate"
            (change)="ttsRateChange()"
            class="tts-select"
            title="Speech speed">
      <option *ngFor="let rate of rates" [value]="rate">{{rate}}x</option>
    </select>
    
    <div class="tts-playback-buttons">
      <ng-container *ngIf="(isTtsPlaying$ | async)?.state || (isTtsPaused$ | async)?.state">
        <!-- Play/Pause button -->
        <button mat-icon-button
                (click)="ttsToggle()" 
                class="tts-control-btn"
                [attr.title]="(isTtsPlaying$ | async)?.state ? 'Pause' : 'Play'">
          <mat-icon>{{(isTtsPlaying$ | async)?.state ? 'pause_circle' : 'play_circle'}}</mat-icon>
        </button>
        
        <!-- Stop button -->
        <button mat-icon-button
                (click)="ttsStop()"
                class="tts-control-btn"
                title="Stop">
          <mat-icon>stop_circle</mat-icon>
        </button>
      </ng-container>
    </div>
  </div>
</div>
